import templateUrl from 'emun.order/email-order-prompt.htm'
import controller from 'emun.order/email-order-prompt.controller'
import open from 'webmodals/open'

export default options => open(Object.assign({
    size: 'sm',
    templateUrl,
    resolve: {
        options: () => options
    },
    bindToController: true,
    controller,
    controllerAs: '$ctrl'
}, (options || {}).modal)).result;